/**
 * Gerencia o título da página centralizando a fonte da verdade via store de módulo.
 * 
 * Evita race conditions entre múltiplos `DocumentTitle` (ex: App vs ProjectDetail)
 * e previne que o título anterior persista após erros/refetch sem mudança de rota.
 * Usa store de módulo para não poluir o JSX com Providers e evitar avisos do Fast Refresh.
 */

let pageTitle: string | undefined;

const listeners = new Set<() => void>();

/** Publica (ou limpa, com `undefined`) o nome da página em tela. */
export function setPageTitle(name: string | undefined): void {
  const next = name?.trim() || undefined;
  if (next === pageTitle) return;
  pageTitle = next;
  for (const listener of listeners) listener();
}

/** Assina mudanças do nome publicado. Devolve a função de cancelamento. */
export function subscribePageTitle(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** O nome publicado agora, ou `undefined` quando nenhuma página publicou. */
export function getPageTitle(): string | undefined {
  return pageTitle;
}
